const liveSearchInput = (
  text: string,
  state: string,
  setState: (text: string) => void,
  timer: ReturnType<typeof setTimeout>,
  startLoading: () => void,
  stopLoading: () => void,
) => {
  startLoading();
  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(() => {
    setState(text);
    stopLoading();
  }, 1000);
};
export default liveSearchInput;
